<template>
<div class="chapter">
<div class="inner_page">
<p class="fmh">Contents</p>
<p class="toc"><span href="#/xhtml/tit#tit" title="Link target outside of Sample">Title Page</span></p>
<p class="toc"><span href="#/xhtml/copyrightnotice#notice" title="Link target outside of Sample">Copyright Notice</span></p>
<p class="toc"><a href="#/xhtml/ded#ded">Dedication</a></p>
<p class="toc-bot"><a href="#/xhtml/author#aut">Author’s Note</a></p>
<p class="toc-bot"><a href="#/xhtml/pro#pro">Prologue</a></p>
<p class="toc"><span class="epub-b">Book One: <a href="#/xhtml/part1#pt1">Encounters 1284</a></span></p>
<p class="toc">Chapter One. <a href="#/xhtml/chapter1#ch1">The Countess</a></p>
<p class="toc">Chapter Two. <a href="#/xhtml/chapter2#ch2">The Boy</a></p>
<p class="toc">Chapter Three. <a href="#/xhtml/chapter3#ch3">The Kings</a></p>
<p class="toc-bot">Chapter Four. <span href="#/xhtml/chapter4#ch4" title="Link target outside of Sample">Meetings</span></p>
<p class="toc"><span class="epub-b">Book Two: <span href="#/xhtml/part2#pt2" title="Link target outside of Sample">The Noble Robert 1290</span></span></p>
<p class="toc">Chapter Five. <span href="#/xhtml/chapter5#ch5" title="Link target outside of Sample">A Laying on of Hands</span></p>
<p class="toc">Chapter Six. <span href="#/xhtml/chapter6#ch6" title="Link target outside of Sample">The Lairds of Lochmaben</span></p>
<p class="toc">Chapter Seven. <span href="#/xhtml/chapter7#ch7" title="Link target outside of Sample">The Patriarch</span></p>
<p class="toc">Chapter Eight. <span href="#/xhtml/chapter8#ch8" title="Link target outside of Sample">A Ride to Perth</span></p>
<p class="toc">Chapter Nine. <span href="#/xhtml/chapter9#ch9" title="Link target outside of Sample">Family Ties</span></p>
<p class="toc-bot">Chapter Ten. <span href="#/xhtml/chapter10#ch10" title="Link target outside of Sample">Alarums</span></p>
<p class="toc"><span class="epub-b">Book Three: <span href="#/xhtml/part3#pt3" title="Link target outside of Sample">Siblings 1292</span></span></p>
<p class="toc">Chapter Eleven. <span href="#/xhtml/chapter11#ch11" title="Link target outside of Sample">A Surfeit of Roberts</span></p>
<p class="toc">Chapter Twelve. <span href="#/xhtml/chapter12#ch12" title="Link target outside of Sample">Silver Spurs</span></p>
<p class="toc-bot">Chapter Thirteen. <span href="#/xhtml/chapter13#ch13" title="Link target outside of Sample">The Dangers of Ideas</span></p>
<p class="toc"><span class="epub-b">Book Four: <span href="#/xhtml/part4#pt4" title="Link target outside of Sample">The English Lordling 1295–1297</span></span></p>
<p class="toc">Chapter Fourteen. <span href="#/xhtml/chapter14#ch14" title="Link target outside of Sample">The Politics of Love</span></p>
<p class="toc">Chapter Fifteen. <span href="#/xhtml/chapter15#ch15" title="Link target outside of Sample">The Politics of Friendship</span></p>
<p class="toc">Chapter Sixteen. <span href="#/xhtml/chapter16#ch16" title="Link target outside of Sample">Natural Wrath</span></p>
<p class="toc">Chapter Seventeen. <span href="#/xhtml/chapter17#ch17" title="Link target outside of Sample">The French Physician</span></p>
<p class="toc">Chapter Eighteen. <span href="#/xhtml/chapter18#ch18" title="Link target outside of Sample">Enchantments and Intrigues</span></p>
<p class="toc">Chapter Nineteen. <span href="#/xhtml/chapter19#ch19" title="Link target outside of Sample">Confessions</span></p>
<p class="toc">Chapter Twenty. <span href="#/xhtml/chapter20#ch20" title="Link target outside of Sample">The Earl of Carrick’s Idyll</span></p>
<p class="toc">Chapter Twenty-One. <span href="#/xhtml/chapter21#ch21" title="Link target outside of Sample">Kings’ Pleasures</span></p>
<p class="toc">Chapter Twenty-Two. <span href="#/xhtml/chapter22#ch22" title="Link target outside of Sample">A Brief and Distant War</span></p>
<p class="toc">Chapter Twenty-Three. <span href="#/xhtml/chapter23#ch23" title="Link target outside of Sample">Lochmaben Revisited</span></p>
<p class="toc">Chapter Twenty-Four. <span href="#/xhtml/chapter24#ch24" title="Link target outside of Sample">Death and Resurrection</span></p>
<p class="toc-bot">Chapter Twenty-Five. <span href="#/xhtml/chapter25#ch25" title="Link target outside of Sample">Lessons in Loyalty</span></p>
<p class="toc-bot"><span href="#/xhtml/epi#epi" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc"><span href="#/xhtml/glossary#glo" title="Link target outside of Sample">Glossary</span></p>
<p class="toc"><span href="#/xhtml/adcard#ad" title="Link target outside of Sample">Also by Jack Whyte</span></p>
<p class="toc"><span href="#/xhtml/copyright#crt" title="Link target outside of Sample">Copyright</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?1efd82fa